export default "__VITE_ASSET__B_ov6gax__"